import { GuideModel } from '@/modules/guide/guide-model';

const { fields } = GuideModel;

export default [
  fields.id,

  fields.createdAt
];
